import React from 'react'
import {connect} from 'react-redux'

import {
  ROLES,
  CONVERSATION_TYPES
} from '../shared/config/constants'

import setFocusedConversation from '../shared/data/actions/set_focused_conversation'

import Conversation from './conversation'
import ExpertConversation from './expert_conversation'
import GroupChatConversation from './group_chat_conversation'

const {NORMAL, EXPERT, GROUP} = CONVERSATION_TYPES

class ConversationDirector extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onConversationFocus = this.onConversationFocus.bind(this)
    this.onConversationBlur = this.onConversationBlur.bind(this)
  }

  onConversationFocus () {
    this.props.focusConversation(this.props.conversation, this.props.index, true)
  }

  onConversationBlur () {
    this.props.focusConversation(this.props.conversation, this.props.index, false)
  }

  renderExpertConversation (conv, index) {
    return (
      <ExpertConversation
        index={index}
        onConversationFocus={this.onConversationFocus}
        onConversationBlur={this.onConversationBlur}
        conversation={conv}/>
    )
  }

  renderNormalConversation (conv, index) {
    return (
      <Conversation
        index={index}
        onConversationFocus={this.onConversationFocus}
        onConversationBlur={this.onConversationBlur}
        conversation={conv}/>
    )
  }

  renderGroupConversation (conv, index) {
    return (
      <GroupChatConversation
        index={index}
        onConversationFocus={this.onConversationFocus}
        onConversationBlur={this.onConversationBlur}
        conversation={conv}/>
    )
  }

  render () {
    const {conversation, currentUser, targetUser} = this.props

    const convType = conversation.get('type')
    const isExpertConversation = (
      (targetUser && targetUser.get('role') === ROLES.EXPERT) ||
      (currentUser && currentUser.get('role') === ROLES.EXPERT)
    )

    if (convType === GROUP) return this.renderGroupConversation(this.props.conversation, this.props.index)
    if (isExpertConversation) return this.renderExpertConversation(this.props.conversation, this.props.index)
    if (convType === NORMAL || (convType === EXPERT && !isExpertConversation)) return this.renderNormalConversation(this.props.conversation, this.props.index)

    return false
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser'),
    targetUser: state.getIn(['users', ownProps.conversation.get('targetId')])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    focusConversation: (conversation, index, isFocused) => dispatch(setFocusedConversation(conversation, index, isFocused))
  }
}

const ConversationDirectorContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationDirector)


export default ConversationDirectorContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_director.js
 **/